<template>
    <div class="sign-hat-box">
        <div class="sign-hat-head">
            <el-page-header @back="goBack" :content="pageTitle"></el-page-header>
            <!-- <div style="flex:1;padding:0 50px;">
                <el-slider
                    v-model="showTime"
                    :step='1'
                    :max="1440"
                    :marks="timeMark"
                    :format-tooltip="formatToolTip"
                    @change="showTimeChange"
                    >
                </el-slider>
            </div> -->
            <div style="margin-left:1vw;">
                <el-date-picker
                    v-model="time"
                    align="right"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期"
                    @change="timeChange"
                    :picker-options="pickerOptions">
                </el-date-picker>
                <el-button type="primary" v-if="!trailDisable" @click="showTrail" style="margin-left:20px;">回看</el-button>
                <el-button type="primary" v-else style="margin-left:20px;">{{curTime}}</el-button>
            </div>
        </div>
        <div class="box-main">
            <baidu-map class="map-box" :center="center" :zoom="16" @ready="handler" @click="getClickInfo">
                <!-- <bm-marker v-for="item in points" @click="clickHandler(item)" :key="item.id" :position="item.position"  :icon="{url: require('../../assets/image/worker_icon.png'), size: {width: 24, height: 40}}">
                </bm-marker> -->
            </baidu-map>
        </div>
    </div>
</template>

<script>
import myHttp from '../../../untils/port';
import util from '../../../untils/util'
export default {
    data(){
        return{
            showTime:0,//路径展示开始时间
            timeMark:{
                0:'00:00',
                // 60:'01:00',
                // 120:'02:00',
                // 180:'03:00',
                // 240:'04:00',
                // 300:'05:00',
                360:'06:00',
                // 420:'07:00',
                // 480:'08:00',
                // 540:'09:00',
                // 600:'10:00',
                // 660:'11:00',
                720:'12:00',
                // 780:'13:00',
                // 840:'14:00',
                // 900:'15:00',
                // 960:'16:00',
                // 1020:'17:00',
                1080:'18:00',
                // 1140:'19:00',
                // 1200:'20:00',
                // 1260:'21:00',
                // 1320:'22:00',
                // 1380:'23:00',
                1440:'24:00',
            },
            time:util.myTime.getCurTime(),
            // time:'2020-06-30',
            pickerOptions: { //时间插件参数
                disabledDate(time) {
                return time.getTime() > Date.now();
                },
                shortcuts: [{
                text: '今天',
                onClick(picker) {
                    picker.$emit('pick', new Date());
                }
                }, {
                text: '昨天',
                onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                }
                }, {
                text: '一周前',
                onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                }
                }]
            },
            trailDisable:false,
            curTime:'',//当前路径的时间
            center: {
                lng: 117.285033,
                lat: 31.86515
            },
            map:undefined,
            BMap:undefined,
            timesOut:undefined,
            pageTitle:'',
            groupId:'',
            personId:'',
            curSn:'',//当前设备sn
            playPoint:[],//回看轨迹（地图轨迹数据）
            dataPoint:[],//轨迹全部数据
            worker:undefined,//当前安全帽
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        this.curSn = params.sn
        this.personId = params.id
        this.pageTitle = params.name
    },
    methods:{
        //获取历史数据
        getData(){
            var that = this
            myHttp.getGpsDataByPersonId({
                projectId:this.groupId,
                sn:this.curSn,
                days:this.time,
                personId:this.personId
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    that.clearBaiDu()
                    var list = resp.data.data.dataBySn||[]
                    that.dataPoint = list
                    if(list.length==0){
                        that.playPoint = []
                        that.$message.error('暂无运行路线！')
                        return
                    }
                    var datas = list
                    var PointArr = [];
                    if(datas.length != 0) {
                        for(let is in datas) {
                            PointArr.push({lat:parseFloat(datas[is].latitude),lng:parseFloat(datas[is].longitude)}) ;   
                        }  
                    }else{
                        PointArr.push({lat:31.855084,lng:117.140395}) ;
                    }
                    var pois = [];//路线
                     for(let i in PointArr) {
                        pois.push(new BMap.Point(PointArr[i].lng,PointArr[i].lat));
                    }
                    that.playPoint = pois
                    
                    if(that.trailDisable){
                        that.dingshi(pois)
                    }
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },
        //
        formatToolTip(val){
            let hour = 0
            let min = 0
            let ms = val * 60
            hour = parseInt(ms / 3600)
            if (hour < 10) {
                hour = '0' + hour.toString()
            } else {
                hour = hour.toString()
            }
            min = parseInt(val % 60)
            if (min < 10) {
                min = '0'+min.toString()
            } else {
                min = min.toString()
            }
            let time = hour + ':' + min
            return time
        },
        //
        showTimeChange(e){
            var hour = parseInt(e/60)
            hour = hour<10?'0'+hour:hour
            var min = parseInt(e%60)
            min = min<10?'0'+min:min
            this.showTimeDate = hour + ':' + min+':00'
            if(this.trailDisable){
                //this.trailDisable = false
                clearInterval(this.timesOut)
            }
            this.getData()
        },
        //监听时间
        timeChange(){
            this.getData()
        },
        //回看
        showTrail(){
            this.dingshi(this.playPoint)
        },

        //地图展示
        handler({ BMap, map }) {
            this.map = map
            this.BMap = BMap
            this.map.enableScrollWheelZoom();
            map.addControl(new BMap.ScaleControl());
            if(this.curSn!=''){
                this.getData()
            }
            //this.getAttendArea()
            // this.getLocation()
        },

        //获取电子围栏
        getAttendArea(){
            var that = this;
            myHttp.getProjectById({
                id: this.groupId
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data.project;
                    that.showFenceArea(data.enclosure);
                    
                } else {
                    that.$message.error(resp.data.msg);
                }
            }, function (error) {
            });
        },
        //展示电子围栏
        showFenceArea(mapArea){
            if (mapArea != undefined && mapArea != ""){
                this.allPoint = JSON.parse(mapArea);
                for (var j = 0; j < this.allPoint.length; j++) {
                    this.currentPonit = this.allPoint[j];
                    var list = [];
                    for (var i = 0; i < this.currentPonit.length; i++) {
                        list.push(new BMap.Point(this.currentPonit[i].lng, this.currentPonit[i].lat));
                        var point = new BMap.Point(this.currentPonit[i].lng, this.currentPonit[i].lat);
                        // pointList.push(point);
                        var marker = new BMap.Marker(point);
                        var index = i + 1;
                        var label = new BMap.Label(index, {
                            offset: new BMap.Size(5, 4)
                        });
                        label.setStyle({
                            background: 'none', color: '#fff', border: 'none'//只要对label样式进行设置就可达到在标注图标上显示数字的效果
                        });
                        marker.setLabel(label);//显示地理名称
                        //this.map.addOverlay(marker);
                    }
                    var polygonList = new BMap.Polygon(list, {
                        strokeColor: "blue",
                        strokeWeight: 2,
                        strokeOpacity: 0.5,
                        strokeStyle: 'dashed',
                        fillOpacity: 0.3
                    });  //创建多边形
                    this.map.addOverlay(polygonList);
                }
                this.currentPonit = []
            }
        },

        dingshi(pois){
            // var pois = this.playPoint
            this.clearBaiDu()
            if(pois.length==0){
                this.$message.error('暂无运行路线！')
                return
            }
            //人
            if(this.worker){
                this.worker.setPosition(pois[0])
                this.map.panTo(pois[0]); 
            }else{
                var worker_icon = new BMap.Icon(require('../../../assets/image/location.png'), new BMap.Size(25,27),{
                    anchor: new BMap.Size(12, 13),//这句表示图片相对于所加的点的位置mapStart
                    imageSize:new BMap.Size(25, 27) //图标所用的图片的大小，此功能的作用等同于CSS中的background-size属性。可用于实现高清屏的高清效果
                });
                this.worker = new BMap.Marker(pois[0],{icon:worker_icon})
                this.map.addOverlay(this.worker);
            }
            
            var that = this
            var i=0
            this.map.panTo(pois[0]);//跳转第一个点
            this.timesOut = setInterval(() => {
                if(i<pois.length){
                    if(i==0){
                        console.log('回放开始！')
                        that.trailDisable = true
                    }
                    i++
                    that.curTime = that.dataPoint[i] && that.dataPoint[i].updateDate||'回看中...'
                    that.play(i,pois)
                }else{
                    console.log('回放结束！')
                    that.curTime = ''
                    that.trailDisable = false
                    clearInterval(that.timesOut)
                }
                
            }, 100);
        },

        play(index,list){
            var point = list[index];
            if(this.map.getDistance(list[index - 1],point).toFixed(2)>20){
                this.map.panTo(point);  
            }
            this.worker.setPosition(point)
            var polyline = new BMap.Polyline([list[index - 1], point], {
                enableEditing: false,//是否启用线编辑，默认为false
                enableClicking: true,//是否响应点击事件，默认为true
                // icons:[icon],
                strokeWeight:'5',//折线的宽度，以像素为单位
                strokeOpacity: 1,//折线的透明度，取值范围0 - 1
                strokeColor:"#349c00" //折线颜色
            });
            this.map.addOverlay(polyline) 
        },

        getClickInfo(e){

        },

        //删除固定的覆盖物
        clearBaiDu(){
            var allOverlay = this.map.getOverlays();
            for(var i = 0;i<allOverlay.length;i++) {
                if(allOverlay[i].toString()=="[object Polyline]"){
                    this.map.removeOverlay(allOverlay[i]);
                }
            }
        },

        //返回
        goBack(){
            this.$router.go(-1)
        },
    }
}
</script>

<style scoped>
    .sign-hat-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .sign-hat-head{
        width: 100%;
        height: 6vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: flex-start;
        justify-items: flex-start;
        padding: 0 1vw;
        background: #fff;
    }
    .box-main{
        width: 100%;
        height: calc( 100% - 6vh );
        position: relative;
        /* padding:0 1vh; */
    }
    .map-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>

<style>

</style>